import { apiFetch } from "../../api/client";
import type { AdminOperationalHealth } from "../../api/types";

/**
 * `GET panel/operational-health` (role Consulta, design.md §8). No
 * `client_id` is ever sent — the server ignores any supplied value and
 * resolves tenant from the trusted principal — so this client never accepts
 * or forwards one (same contract as `features/overview/api.ts#getOverview`).
 */
export function getOperationalHealth(signal: AbortSignal): Promise<AdminOperationalHealth> {
  return apiFetch<AdminOperationalHealth>("/panel/operational-health", { signal });
}
